export const EVERGREEN_COLLECTIONS_TEST_NAME = 'HP_EvergreenCollectionsUX_March2026';
